<template>
<b-container>

<p class="h5 mb-4">{{pagePrompt}}</p>

<b-row>
  <b-col cols="12" lg="12">
    <BaseSelector v-model="currentlyEmployed" 
      :v="$v.currentlyEmployed"
      :label="$t('labels.currentlyEmployed')"
      :options=yesNoUnknownOptions
      slug="currentlyEmployed"/>
  </b-col>
</b-row>

<div v-if="currentlyEmployed === 'Y'">
  <b-row v-if="false">
    <b-col>
      <BaseRadioInput v-model="requestExclusionLetter"
                          :v="$v.requestExclusionLetter"
                          :label="$t('labels.requestExclusionLetter')"
                          :options=yesNoOptions
                          slug="requestExclusionLetter"/>
    </b-col>
  </b-row>

  <p v-if="requestExclusionLetter === 'Y'" v-show="false">{{emailPrompt}}</p>

  <b-button v-b-modal.modal-employer variant="primary" style="margin-bottom:20px;">{{$t('workPage.employer')}}</b-button>

    <b-list-group>
      <b-list-group-item class="d-flex justify-content-between align-items-center"
        v-for="(employer, idx) in employers" v-bind:key="idx">
        {{employer.tempName}} {{employer.employerName}} - {{employer.workplaceSetting}}
        <b-button v-if="false" variant="primary" size="sm" @click="edit(idx)">Edit</b-button>
      </b-list-group-item>
    </b-list-group>
</div>

    <b-modal id="modal-employer" size="lg" hide-header hide-footer scrollable >
      <h2>{{$t('workPage.employer')}}</h2>
      <hr/>
      <form ref="form" @submit.prevent="save">
        <b-row>
          <b-col cols="12" lg="12">
            <BaseSelector v-model="employer.workplaceSetting"
              :v="$v.employer.workplaceSetting"
              :label="$t('labels.workplaceSetting')"
              :options=workplaceSettings
              slug="workplaceSetting"/>
          </b-col>
        </b-row>

        <b-row v-if="promptForHcwRole">
          <b-col cols="12" lg="12">
            <BaseSelector v-model="employer.hcwRole"
              :v="$v.employer.hcwRole"
              :label="$t('labels.hcwRole')"
              :options=hcwRoleOptions
              slug="hcwRole"/>
          </b-col>
        </b-row>

        <b-row v-if="employer.workplaceSetting === 'HEALTHCARE'">
          <b-col cols="12" lg="12">
            <BaseFacilitySelector v-model="hcwEmployerObj"
              :v="$v.hcwEmployerObj"
              :label="$t('labels.employerName')"
              slug="hcwEmployer"
              :tip="$t('tips.otherSelection')"/>
          </b-col>
        </b-row>

        <b-row v-if="employer.workplaceSetting === 'CORRECTIONS'">
          <b-col cols="12" lg="12">
            <BaseCorrectionsSelector v-model="corrEmployerObj"
              :v="$v.corrEmployerObj"
              :label="$t('labels.employerName')"
              slug="corrEmployer"
              :tip="$t('tips.otherSelection')"/>
          </b-col>
        </b-row>

        <b-row v-if="employer.workplaceSetting === 'COLLEGE_UNIV'">
          <b-col cols="12" lg="12">
            <BaseUniSchoolSelector v-model="schoolObj"
              :v="$v.schoolObj"
              :label="$t('labels.employerName')"
              slug="schoolName"
              :tip="$t('tips.otherSelection')"/>
          </b-col>
        </b-row>

        <b-row v-if="employer.workplaceSetting === 'K12'">
          <b-col cols="12" lg="12">
            <BaseK12SchoolSelector v-model="schoolObj"
              :v="$v.schoolObj"
              :label="$t('labels.employerName')"
              slug="schoolName"
              :tip="$t('tips.otherSelection')"/>
          </b-col>
        </b-row>

        <b-row v-if="employer.workplaceSetting === 'CHILDCARE'">
          <b-col cols="12" lg="12">
            <BaseChildCareSelector v-model="schoolObj"
              :v="$v.schoolObj"
              :label="$t('labels.employerName')"
              slug="schoolName"
              :tip="$t('tips.otherSelection')"/>
          </b-col>
        </b-row>

        <b-row v-if="!useDropDown">
          <b-col cols="12" lg="12">
            <BaseTextInput v-model="employer.employerName"
                                :v="$v.employer.employerName"
                                :label="$t('labels.employerName')"
                                slug="employerName"/>
          </b-col>
        </b-row>

        <b-row v-if="employer.employerName === 'OTHER' || employer.employerName === 'DAY_0000' || employer.employerName === 'C-00001' || employer.employerName === 'C-00171' || employer.employerName === 'C-00172' ">
          <b-col cols="12" lg="12">
            <BaseTextInput v-model="employer.employerOther"
                                :v="$v.employer.employerOther"
                                :label="$t('labels.employerNameOther')"
                                slug="employerOther"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="12">
            <BaseTextInput v-model="employer.employerAddress"
                                :v="$v.employer.employerAddress"
                                :label="$t('labels.employerAddress')"
                                slug="employerAddress"/>
          </b-col>
        </b-row>

        <b-row v-if="!promptForHcwRole">
          <b-col cols="12" lg="12">
            <BaseTextInput v-model="employer.occupation"
                                :v="$v.employer.occupation"
                                :label="$t('labels.occupation')"
                                slug="occupation"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="12">
            <BaseRadioInput v-model="employer.attendedInfectious"
                                :v="$v.employer.attendedInfectious"
                                :label="$t('labels.employerattendedInfectious')"
                                :options=yesNoUnknownOptions
                                slug="employerShare"/>
          </b-col>
        </b-row>

        <b-row v-if="employer.attendedInfectious === 'Y'">
          <b-col cols="12" lg="12">
            <BaseTextInput v-model="employer.infectiousDates"
                                :v="$v.employer.infectiousDates"
                                :label="$t('labels.infectiousDates')"
                                slug="infectiousDates"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="12">
            <BaseRadioInput v-model="employer.employerShare"
                                :v="$v.employer.employerShare"
                                :label="$t('labels.employerShare')"
                                :options=yesNoOptions
                                slug="employerShare"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="12">
            <BaseTextInput v-model="employer.employerContactName"
                                :v="$v.employer.employerContactName"
                                :label="$t('labels.employerContactName')"
                                slug="employerContactName"/>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" lg="12">
            <BaseMaskedTextInput v-model="employer.employerContactInfo"
                                :v="$v.employer.employerContactInfo"
                                :label="$t('labels.employerContactInfo')"
                                 mask="(###)###-####"
                                slug="employerContactInfo"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button @click="close" style="margin-right:15px;">{{$t('buttons.cancel')}}</b-button>
            <b-button type="submit" variant="primary" :disabled="$v.employer.$invalid">{{$t('buttons.save')}}</b-button>
          </b-col>
        </b-row>
      </form>
    </b-modal>

</b-container>

</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import moment from 'moment'
import _ from "lodash"
import i18n from '@/i18n'

export default {
  mixins: [
    commonOptions
  ],

  props: {
    symptoms: [Object],
    email: String
  },

  data: () => ({
    currentlyEmployed: null,
    requestExclusionLetter: '',
    employer: {
      workplaceSetting: '',
      employerName: '',
      employerAddress: '',
      occupation: '',
      employerShare: '',
      employerContactName: '',
      employerContactInfo: '',
      hcwRole: '',
      employerOther: '',
      attendedInfectious: '',
      infectiousDates: '',

    },
    employers: [],
    editedIndex: -1,
    hcwEmployerObj: {},
    corrEmployerObj: {},
    schoolObj: {},
    defaultEmployer: {
        workplaceSetting: '',
        employerName: '',
        employerAddress: '',
        occupation: '',
        employerShare: '',
        employerContactName: '',
        employerContactInfo: '',
        hcwRole: '',
        employerOther: '',
        attendedInfectious: '',
        infectiousDates: '',
      },
  }),
  validations() {
    return {
      currentlyEmployed: { required : false },
      requestExclusionLetter: { required: false },
      hcwEmployerObj: { required: false },
      corrEmployerObj: { required: false },
      schoolObj: { required: false },

      employer: {
        workplaceSetting: { required, minLength: minLength(1) },
        employerName: { required: false },  
        employerAddress: { required: false },
        occupation: { required: false },
        employerShare: { required: false },
        employerContactName: { required: false },
        employerContactInfo: { required: false },
        hcwRole: { required: false },
        tempName: { required: false },
        employerOther: { required: false, maxLength: maxLength(100) },
        attendedInfectious: { required: false },
        infectiousDates: { required: false },
      },

      form: [  ]
    }
  },

  watch: {

    hcwEmployerObj: function() {
        if (this.hcwEmployerObj && this.hcwEmployerObj.value) {
          this.employer.employerName =  this.hcwEmployerObj.value
          this.employer.tempName=  this.hcwEmployerObj.text
        } else {
          this.employer.employerName = ''
        }
    },

    corrEmployerObj: function() {      
        if (this.corrEmployerObj && this.corrEmployerObj.value) {
          this.employer.employerName =  this.corrEmployerObj.value
          this.employer.tempName=  this.corrEmployerObj.text
        } else {
          this.employer.employerName = ''
        }
    },

    schoolObj: function() {      
        if (this.schoolObj && this.schoolObj.value) {
          this.employer.employerName =  this.schoolObj.value
          this.employer.tempName=  this.schoolObj.text
        } else {
          this.employer.employerName = ''
        }
    }

  },

  computed: {
    pagePrompt() {
      var exposePeriodStart
      if (this.symptoms.covidSymptoms === 'Y') {
        var startDate = moment(this.symptoms.covidSymptomsStart)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else if (this.symptoms.covidLastTested !== '') {
        startDate = moment(this.symptoms.covidLastTested)
        exposePeriodStart = startDate.subtract(2, 'days').format('MM/DD/YYYY')
      } else {
        exposePeriodStart = moment().subtract(2, 'days').format('MM/DD/YYYY')
      }

      return this.$i18n.t('workPage.pagePrompt', this.$root.$i18n.locale, {date: exposePeriodStart})
    },

    promptForHcwRole() {
      return (this.employer.workplaceSetting === 'HEALTHCARE' || 
              this.employer.workplaceSetting === 'LTC' || 
              this.employer.workplaceSetting === 'RES_TREAT')
    },

    promptForSchoolName() {
      return (this.employer.workplaceSetting === 'COLLEGE_UNIV' || 
              this.employer.workplaceSetting === 'K12' || 
              this.employer.workplaceSetting === 'CHILDCARE')    
    },

    useDropDown() {
        return (this.employer.workplaceSetting === 'HEALTHCARE' || 
              this.employer.workplaceSetting === 'CORRECTIONS' ||
              this.employer.workplaceSetting === 'COLLEGE_UNIV' ||
              this.employer.workplaceSetting === 'K12' ||
              this.employer.workplaceSetting === 'CHILDCARE' 
        )
    },

    emailPrompt() {
      return this.$i18n.t('workPage.emailPrompt', this.$root.$i18n.locale, {email: this.email})
    },
  },

  methods: {
    validate() {
      this.$v.form.$touch();
      var isValid = !this.$v.form.$invalid
      this.$emit('on-validate', this.$data, isValid)
      return isValid
    },

    save () {
      if (this.editedIndex > -1) {
          Object.assign(this.employers[this.editedIndex], this.employer)
      } else {            
          this.employers.push(this.employer)
      }
      this.close()
    },

    close () {
      this.$bvModal.hide('modal-employer')
      setTimeout(() => {
        this.employer = Object.assign({}, this.defaultEmployer)
        this.hcwEmployerObj = {}
        this.corrEmployerObj = {}
        this.schoolObj = {}
        this.editedIndex = -1
        this.$nextTick(() => { this.$v.employer.$reset() })
      }, 300)
    },

    edit (idx) {
      this.editedIndex = idx
      this.employer = Object.assign({}, this.employers[idx])
      this.$bvModal.show('modal-employer')
    },
  }
}
</script>

<style>

</style>
